const FRIEND_LISTS_NAMESPACE = "friendLists";
const CUSTOMERS_NAMESPACE = "customers";
const SECURITY_NAMESPACE = "security";
const CART_NAMESPACE = "cart";
const TICKETS_NAMESPACE = "tickets";

export function customersNamespaced(name) {
  return `${CUSTOMERS_NAMESPACE}/${name}`;
}

export function securityNamespaced(name) {
  return `${SECURITY_NAMESPACE}/${name}`;
}

export function friendListsNamespaced(name) {
  return `${FRIEND_LISTS_NAMESPACE}/${name}`;
}

export function ticketsNamespaced(name) {
  return `${TICKETS_NAMESPACE}/${name}`;
}

export function cartNamespaced(name) {
  return `${CART_NAMESPACE}/${name}`;
}

export function commitFriendLists(store, type, payload) {
  store.commit(friendListsNamespaced(type), payload);
}

export function commitCustomers(store, type, payload) {
  store.commit(customersNamespaced(type), payload);
}

export function dispatchFriendLists(store, action, payload) {
  store.dispatch(friendListsNamespaced(action), payload);
}

export function dispatchCustomers(store, action, payload) {
  store.dispatch(customersNamespaced(action), payload);
}

export function dispatchCart(store, action, payload) {
  store.dispatch(cartNamespaced(action), payload);
}

export function dispatchTickets(store, action, payload) {
  store.dispatch(ticketsNamespaced(action), payload);
}
